import React from 'react';

import styled from 'styled-components';

import {
    useIsContactConnectionItemDefault,
    useEditContactConnectionItemDefault,
} from '@hooks/API/Contact/UseContactConnections';

import FlexContainer from '@components/Gui/FlexContainer';
import { PhoneLine } from '@components/Gui/NwContactInfo';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const DefaultItem = styled.div`
    font-weight: ${(props) => props.isDefault && 'bold'};
`;

const PhoneItem = ({ phone, readOnly, onEdit, onDelete, contactID }) => {
    const { mutate: onSetItemDefault } = useEditContactConnectionItemDefault();

    const setDefault = () => {
        onSetItemDefault({ itemType: 'phone', idItem: phone.ID, contactID: contactID });
    };

    const isDefault = useIsContactConnectionItemDefault('phone', phone.ID, contactID);

    let actions = [
        { name: '', key: 'edit', pinned: true, icon: byPrefixAndName.fasl['pen'], action: onEdit },
        { name: 'set as default', key: 'default', icon: byPrefixAndName.fasl['bookmark'], action: setDefault },
        {
            name: 'delete',
            type: 'delete',
            key: 'delete',
            icon: byPrefixAndName.fasl['trash-alt'],
            confirmationPlacement: 'left',
            action: onDelete,
        },
    ];

    actions = actions.filter((action) => !(action.key === 'default' && isDefault));

    return (
        <FlexContainer justifyContent="space-between">
            <DefaultItem isDefault={isDefault}>
                <PhoneLine phoneType={phone.Type} phoneNumber={phone.Number} phoneNote={phone.Note} />
            </DefaultItem>
            {!readOnly && <NwDropDownMenu size="small" actions={actions} />}
        </FlexContainer>
    );
};

export default PhoneItem;
